/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Deactivate_TitleInputs */



/**
* | output |
* | --- |
* | "Deactivate" |
*
* @param {Developer_Deactivate_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_deactivate_title = /** @type {((inputs?: Developer_Deactivate_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Deactivate_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactiver")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desactivar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desativar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disattiva")
	return /** @type {LocalizedString} */ ("Deactivate")
});